const projects = [
  {
    title: "Pokemon App",
    img: [
      "/img/Pokemon/img1.jpg",
      "/img/Pokemon/img2.jpg",
      "/img/Pokemon/img3.jpg",
    ],
    description: "Individual project for Herny Bootcamp",
    large_text:
      "In this application we fetch the Pokemon API, to query all the data of the pokemons. The aplication allows to filter, search, sort, and create pokemons, such as get the pokemon details.",
    created: "April, 2021",
    updated: "June, 2021",
    labels: "React, Redux, PostgreSQL, Sequelize, Express",
    type: "Other",
    status: "production",
    link: "https://pokemon-app-gm.herokuapp.com/",
  },
  {
    title: "Henry Ecommerce",
    img: [
      "/img/EcommerceHenry/img1.jpg",
      "/img/EcommerceHenry/img2.jpg",
      "/img/EcommerceHenry/img3.jpg",
      "/img/EcommerceHenry/img4.jpg",
      "/img/EcommerceHenry/img5.jpg",
      "/img/EcommerceHenry/img6.jpg",
      "/img/EcommerceHenry/img7.jpg",
    ],
    description: "Final project for the Henry Bootcamp.",
    large_text:
      "Ecommerce of electronic devices and computing accesories. This application counts with user authentication, shopping, cart, payments, wishlist admin dashboard, and other features. My responsability in the team was almost all the frontend components such as the product catalogue, cart view, lading page with product sliders, payment steps, login and the hover cart component. This aplication was made by a 6 member group",
    created: "September, 2020",
    updated: "Febrery, 2021",
    labels: "Mongo, Node, Express, React, redux",
    type: "Ecommerce",
    status: "production",
    link: "https://store-commerce-pi.vercel.app/",
  },
  {
    title: "Amazon Clone",
    img: [
      "/img/Amazon/img1.jpg",
      "/img/Amazon/img2.jpg",
      "/img/Amazon/img3.jpg",
      "/img/Amazon/img4.jpg",
    ],
    description: "Frontend Clone of Amazon",
    large_text:
      "In this oportunity we replicate the basic functionality of a regular Ecommerce including shopping cart, and product display. The site includes authentication with Firebase.",
    created: "September, 2020",
    updated: "Febrery, 2021",
    labels: "Firebase, React",
    type: "Ecommerce",
    status: "development",
  },
  {
    title: "Yelp Clone",
    img: ["/img/Yelp/img1.jpg", "/img/Yelp/img2.jpg", "/img/Yelp/img3.jpg"],
    description: "Frontend Clone of Yelp",
    large_text:
      "In this oportunity we replicate the basic functionality of Yelp. This application allows to display, filter, sort and search for the services, businesses and by location, for instance Burguers in Berlin, or Barbers in San Francisco",
    created: "June, 2021",
    updated: "June, 2021",
    labels: "React",
    type: "social-network",
    status: "production",
    link: "https://yelp-app-gm.herokuapp.com/",
  },
];

export default projects;
